import { Routes } from '@angular/router';

import * as LayoutHelpers from '../../services/layout.routing.helpers';

import { DefaultLayoutComponent } from './default-layout.component';

import { ApplicationHomePageName } from '@core/domain/models/application-section.model';
import { StyleHeaderEnum, ThemeTypeEnum } from '@layout/domain/models/layout.models';
import { canActivateChildLayout } from '@layout/ui/services/layout.can-activate-child';

export const defaultLayoutRoutes: Routes = [
    {
        path: '',
        component: DefaultLayoutComponent,
        canActivateChild: [canActivateChildLayout],
        runGuardsAndResolvers: 'always',
        children: [
            {
                path: 'my-account',
                data: { pageName: 'ItxMyAccountPage', footer: { disabled: true } },
                loadChildren: () => import('@pages/my-account/my-account.module').then((m) => m.MyAccountModule),
            },
            {
                path: 'user/account',
                data: { pageName: 'ItxAngularUserPage', footer: { disabled: true } },
                loadChildren: () => import('@pages/my-account/my-account.module').then((m) => m.MyAccountModule),
            },
            {
                path: 'microsite/:seoId',
                data: { pageName: 'ItxMicrositePage', footer: { disabled: true } },
                loadChildren: () => import('@pages/microsite/microsite.module').then((m) => m.MicrositeModule),
            },
            {
                path: 'multicamera/:seoId',
                data: {
                    pageName: 'ItxMulticameraPage',
                    footer: { disabled: true },
                    themeMobile: ThemeTypeEnum.COMPACT,
                    headerStyleMobile: StyleHeaderEnum.BLEND,
                    themeDesktop: ThemeTypeEnum.COMPACT,
                    headerStyleDesktop: StyleHeaderEnum.COMPACT,
                },
                loadComponent: () => import('@pages/microsite/components/microsite-360-view/microsite-360-view.component').then((m) => m.Microsite360ViewComponent),
            },
            // Server Side Rendering
            {
                matcher: LayoutHelpers.homesWomenMatcher,
                data: {
                    pageName: ApplicationHomePageName.WOMEN,
                    footer: { disabled: true },
                },
                loadChildren: () => import('@pages/home/home-page.module').then((m) => m.HomePageModule),
            },
            {
                matcher: LayoutHelpers.homesMenMatcher,
                data: {
                    pageName: ApplicationHomePageName.MEN,
                },
                loadChildren: () => import('@pages/home/home-page.module').then((m) => m.HomePageModule),
            },
            {
                matcher: LayoutHelpers.categoryMatcher,
                data: { pageName: 'ItxCategoryPage' },
                loadChildren: () => import('@pages/category/category-page.module').then((m) => m.CategoryPageModule),
            },
            {
                matcher: LayoutHelpers.productMatcher,
                data: { pageName: 'ItxProductPage' },
                loadChildren: () => import('@pages/product/product-page.module').then((m) => m.ProductPageModule),
            },
            {
                matcher: LayoutHelpers.collectionsMatcher,
                data: { pageName: 'ItxCollectionPage' },
                loadChildren: () => import('@pages/collection/collection-page.module').then((m) => m.CollectionPageModule),
            },
            // Client Side Rendering
            {
                matcher: LayoutHelpers.staticMatcher,
                data: { pageName: 'ItxAngularCmsRenderPage' },
                loadChildren: () => import('@pages/cms-render-page/cms-render-page.module').then((m) => m.CmsRenderPageModule),
            },
            {
                path: 'massimo-dutti-feel',
                data: { pageName: 'ItxMassimoDuttiFeelPage' },
                loadChildren: () => import('@pages/feel/feel.module').then((m) => m.FeelModule),
            },
            {
                path: 'subscription',
                loadChildren: () => import('@pages/newsletter/newsletter-page.module').then((m) => m.NewsletterPageModule),
            },
            {
                path: 'bags',
                data: {
                    pageName: 'ItxBagCollectionPage',
                    themeMobile: ThemeTypeEnum.PHANTOM,
                    themeDesktop: ThemeTypeEnum.PHANTOM,
                    headerStyleMobile: StyleHeaderEnum.BLEND,
                    headerStyleDesktop: StyleHeaderEnum.BLEND,
                    footer: { disabled: true },
                },
                loadChildren: () => import('@features/bag-collection/ui/bag-collection.ui.module').then((c) => c.BagCollectionUiModule),
            },
            {
                path: 'lookbook/:slug',
                data: { pageName: 'ItxAngularLookbookPage' },
                loadChildren: () => import('@pages/lookbook/lookbook-page.module').then((m) => m.LookbookPageModule),
            },
            {
                path: 'search',
                data: { pageName: 'ItxSearchPage', footer: { disabled: true } },
                loadChildren: () => import('@pages/search/search-page.module').then((m) => m.SearchPageModule),
            },
            {
                matcher: LayoutHelpers.errorMatcher,
                data: { pageName: 'ItxErrorPage' },
                loadChildren: () => import('@shared/errors/error-page.module').then((m) => m.ErrorPageModule),
            },
            {
                path: 'error-ssr',
                data: { pageName: 'ItxErrorPage' },
                loadComponent: () => import('@shared/errors/components/error-not-found/error-not-found-template.component').then((m) => m.ErrorNotFoundTemplateComponent),
            },
        ],
    },
];
